export default class WebcamManager {
    private webcamStream: MediaStream | null = null; // MediaStream della webcam attiva
    private videoTrack: MediaStreamTrack | null = null; // Traccia video della webcam attiva
    private audioTrack: MediaStreamTrack | null = null; // Traccia audio (microfono) della webcam attiva
    public isVideoActive: boolean = false; // Indica se la traccia video è attiva
    public isAudioActive: boolean = false; // Indica se la traccia audio (microfono) è attiva
  
    // Metodo per attivare la webcam
    public activateWebcam = async (): Promise<void> => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        const videoTrack = stream.getVideoTracks()[0];
        const audioTrack = stream.getAudioTracks()[0];
  
        if (videoTrack) {
          this.webcamStream = stream;
          this.videoTrack = videoTrack;
          this.isVideoActive = true;
        }
  
        if (audioTrack) {
          this.audioTrack = audioTrack;
          this.isAudioActive = true;
        }
  
      } catch (error) {
        console.error('Errore durante l\'attivazione della webcam:', error);
      }
    };
  
    // Metodo per disattivare la webcam
    public deactivateWebcam = (): void => {
      if (this.webcamStream) {
        this.webcamStream.getTracks().forEach(track => track.stop());
        this.webcamStream = null;
        this.videoTrack = null;
        this.audioTrack = null;
        this.isVideoActive = false;
        this.isAudioActive = false;
      }
    };
  }
  